// Static event list — update here and redeploy to publish changes
// Source of truth for the Schedule section
export const events = [
  {
    id: 'evt-montgomery-2026',
    title: 'Montgomery Co Team Clinic',
    date: 'June 2, 2026',
    location: 'Montgomery City, MO',
    event_type: 'Team Clinic',
    description: ''
  },
  {
    id: 'evt-kinderhook-2026',
    title: 'Kinderhook Small Group Training',
    date: 'June 3, 2026',
    location: 'Kinderhook, IL',
    event_type: 'Small Group',
    description: ''
  },
  {
    id: 'evt-friday-fuse-2026',
    title: 'Friday Fuse',
    date: 'June 5, 2026',
    location: 'Quincy, IL',
    event_type: 'Clinic',
    description: ''
  },
  {
    id: 'evt-highland-2026',
    title: 'Highland Team Training',
    date: 'June 8 & 10, 2026',
    location: 'Ewing, MO',
    event_type: 'Team Camp',
    description: ''
  }
];
